import React from "react";

const Card = ({ children, className = "" }) => {
  return (
    <div
      className={[
        "w-full rounded-xl bg-white p-8 shadow-[0_12px_24px_rgba(15,23,42,0.12)]",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </div>
  );
};

export default Card;
